module.exports = __webpack_public_path__ + "static/media/metop_ndp.7300ad4b.png";